import React, { Component } from 'react';
import { formats, formatsText } from '../../utils/imagesAccept';
import { allNotifications } from '../../utils/toastify';
const { notifyErrorBottomRight } = allNotifications;

const Wrapper = Comp =>
  class extends Component {
    state = {
      imagesList: [],
      imagesPending: [],
      disabledImages: false,
      valueJustify: false,
      changePending: false,
      text: '',
      error: false,
      timesRedirected: 1,
      resorted: false
    };

    modalRef = React.createRef();

    notify = message => notifyErrorBottomRight(message);

    handleTextOn = e => {
      this.setState({
        valueJustify: !!e.target.value,
        text: e.target.value
      });
    };
    /*
    listImages = async data => {
      const response = await services.lambda('getImages', data);
      this.setState({ imagesList: response });
    };
*/
    readFile = file =>
      new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(file);
      });

    /*compress = file =>
      new Promise(resolve => {
        Resizer.imageFileResizer(file, 720, 1280, 'JPEG', 60, 0, uri => resolve(uri), 'blob');
      });*/

    imageValidation = (event, description_image) => this.changeFileImage(event, description_image);

    changeFileImage = async (event, description_image) => {
      let files = event.target.files[0];
      const securityMaxImgSize = 5000000;

      if (!files) return;

      if (files.size > securityMaxImgSize) {
        this.setState({ error: true });
        this.notify(`A imagem deve ter menos de 5Mb.`);
        return;
      }

      console.log('Files...', files);

      // if (!formats.some(f => files.type.includes(f))) { // filter by MIME type
      if (
        !formats.some(f =>
          files.name
            .split('.')
            .pop()
            .toLowerCase()
            .includes(f.toLowerCase())
        )
      ) {
        // filter by extension in file name
        this.setState({ error: true });
        this.notify(`As extensões válidas são ${formatsText}.`);
        return;
      }

      /*if (files.size > maxImgSize) {
        const { name, lastModifiedDate } = files;
        files = await this.compress(files);
        files.name = name;
        files.lastModifiedDate = lastModifiedDate;
      }*/

      const promises = await this.readFile(files).then(result => {
        const newArrayImages = this.state.imagesPending;
        const objectURL = window.URL.createObjectURL(files); // link virtual da imagem

        newArrayImages.push({
          name: files.name,
          src: objectURL,
          type: `.${files.type.split('/')[1]}`,
          file: files,
          categImg: description_image
        });

        this.setState({
          imagesPending: newArrayImages,
          tImages: this.state.tImages + 1
        });
      });

      await Promise.resolve(promises);
    };

    deleteElementPedding = index => {
      const newListImage = this.state.imagesPending;
      newListImage.splice(index, 1);

      this.setState({ imagesPending: newListImage });
    };

    resortGlossa = async () => {
      const { orcamento, codProced } = this.props;

      if (this.props.status === 'GLOSADO') {
        /*try {
          const promisesImages = imagesPending.map(image =>
            services.gto_ME('addImageGlosa_ME', { image, planId, idCredenciado, procedureId })
          );
        } catch (err) {
          this.notify(err.message);
        }*/

        this.setState({ imagesPending: [], resorted: true });
        this.listImages({ orcamento, codProced });

        this.modalRef.current.setState({ modalActive: true });
      }
    };

    redirect = glosaCount => {
      const canRedirect = glosaCount - this.state.timesRedirected <= 0;

      if (canRedirect) {
        return this.props.history.push('/guias');
      }

      this.setState({ timesRedirected: this.state.timesRedirected + 1 });
    };

    componentDidMount = () => {
      const { orcamento, codProced } = this.props;

      /**
       * Essa chamada de listImages poderia ser retirada, pois após enviar as imagens, o item será atualizado para em analise
       * no entanto, no caso de um refresh exatamente desta página, a lista de GTOs ainda não foi recarregada
       * e com isso, seria exibido o estado antigo do card, que era de pendente imagem ou glosado.
       * Esta função, estando aqui, tem a responsabilidade redundante de verificar se o card está no status correto
       */

      if (orcamento && codProced) {
        this.listImages({ orcamento, codProced });
      }
    };

    render() {
      return (
        <Comp
          {...this.state}
          {...this.props}
          changeFileImage={this.changeFileImage}
          imageValidation={this.imageValidation}
          deleteElementPedding={this.deleteElementPedding}
          resortGlossa={this.resortGlossa}
          handleTextOn={this.handleTextOn}
          modalRef={this.modalRef}
          redirect={this.redirect}
        />
      );
    }
  };

export default Wrapper;
